/* excel 导入(上传) */
import baseUrl from '../config/index.js'
//const donwLoadUrl = "http://192.168.2.127:8080";
//const donwLoadUrl = "http://127.0.0.1:8080";
//const donwLoadUrl = "http://jxc.coopwin.vip";
//const donwLoadUrl = "";
const donwLoadUrl = baseUrl;

const excelUpload = {
  purchaseinstock:"/purchasemng/purchaseinstock/excel/importmaterial",//采购入库上传
  purchasebackstock:"/purchasemng/purchasebackstock/excel/importmaterial",//采购
  saleOutStock:"/salemng/saleOutStock/excel/importmaterial",//销售出库
  salereturn:"/salemng/salereturn/excel/importmaterial",//销售退货
  stockadjust:"/stockmng/stockadjust/excel/importmaterial",//库存调整
  customer:"/mast/customerymng/customer/excel/importmaterial",//客户
  supplier:"/mast/suppliermng/supplier/excel/importmaterial",//供应商
  material:"/mast/materialmng/material/excel/importmaterial",//物料
}

/* excel 导出(下载) */
/* const excelDownload = {
  purchaseinstock:donwLoadUrl+"/purchasemng/purchaseinstock/excel/tpl",//采购入库模板下载
  purchasebackstock:donwLoadUrl+"/purchasemng/purchasebackstock/excel/tpl",//采购退货
  saleOutStock:donwLoadUrl+"/salemng/saleOutStock/excel/tpl",//销售出库
  salereturn:donwLoadUrl+"/salemng/salereturn/excel/tpl",//销售退货
  stockadjust:donwLoadUrl+"/stockmng/stockadjust/excel/tpl",//库存调整
} */

const excelDownload = {
  purchaseinstock:"/purchasemng/purchaseinstock/excel/tpl",//采购入库模板下载
  purchasebackstock:"/purchasemng/purchasebackstock/excel/tpl",//采购退货
  saleOutStock:"/salemng/saleOutStock/excel/tpl",//销售出库
  BomMaterialOutStock:"/productplan/bom/bomdefine/excel/tpl",//Bom物料导入
  salereturn:"/salemng/salereturn/excel/tpl",//销售退货
  stockadjust:"/stockmng/stockadjust/excel/tpl",//库存调整
  customer:"/mast/customerymng/customer/excel/tpl",//客户
  supplier:"/mast/suppliermng/supplier/excel/tpl",//供应商
  material:"/mast/materialmng/material/excel/tpl",//物料
}

/* 导出 */
const excelExport = { 
 purchaseinstock: "/purchasemng/purchaseinstock/excel/exportmaterial",//采购统计
 saleOutStock:"/salemng/saleOutStock/excel/exportmaterial",//销售统计
 BomMaterialOutStock:"/productplan/bom/bomdefine/excel/tpl",//Bom物料导入
 inventory:"/stockmng/currentInventory/excel/exportmaterial",//当期库存
 periodinventory:"/stockmng/periodinventory/excel/exportmaterial",//期间库存
 jxc:"/stockmng/periodinventory/excel/exportperiodmaterial",//进销
};

export{
	excelUpload,
  excelDownload,
  excelExport
}
